<style lang="less">
  .anchorBL{ display: none !important;}
  .editor{ img{ width:auto; height:auto; max-width:100%; } p{ margin-bottom:inherit; } }
  .FTemplate{
    .titleTable{ width:100%; text-align:center; }
    .headerTable{ width:100%; }
    >table{
      width:100%; border-collapse:collapse; line-height:25px;
      .tdHeader{ text-align:center; min-width:20%; max-width:30%; color:#333; }
      img{ max-width:400px; max-height:300px; }
      td >*{ width:100% !important; word-break:break-all; word-wrap:break-word; }
      td{ .textarea{ resize:none; padding:0; } }
    }
  }

  /* ========== 富文本编辑器（Quill）— FReport 编辑模式 ========== */
  .freport-quill-wrap {
    width: 100%;
    :deep(.ql-toolbar) {
      border-color: var(--border-color, #e5e6eb) !important;
      background: var(--card-bg, #fff);
      border-radius: 4px 4px 0 0;
      display: block !important;
      width: 100% !important;
    }
    :deep(.ql-container) {
      border-color: var(--border-color, #e5e6eb) !important;
      background: var(--card-bg, #fff);
      border-radius: 0 0 4px 4px;
      min-height: 200px !important;
      display: block !important;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'PingFang SC', sans-serif;
      font-size: 14px;
      .ql-editor {
        min-height: 180px !important;
        color: var(--text-color, #1d2129);
        &.ql-blank::before { color: var(--text-secondary, #86909c) !important; font-style: normal; }
      }
    }
  }

  /* ========== FReport 查看模式：editor 字段 HTML 渲染 ========== */
  .freport-editor-detail {
    width: 100%;
    word-break: break-word;
    line-height: 1.6;
    img { max-width: 100%; height: auto; }
    p { margin: 4px 0; }
  }
</style>
<style lang="less" scoped>
  @import "~@/public/less/index.less";
  .fan-component{ width:100%; }
</style>

<script>
import { h, resolveComponent, markRaw } from 'vue'
import md5 from 'md5'
import FCodeEditor from 'vue-json-editor'
// Vue 3 富文本编辑器
import '@vueup/vue-quill/dist/vue-quill.snow.css'
import print from '@/public/utils/print'
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')

export default {
  name:'FReport',
  props:{ superApi:String, template:String, mold:String, superData:Object, mixData:Object },
  data(){
    return {
      page:{}, def:{ page:{ loading:{page:false,submit:false}, printData:''} },
      data:{ columns:{}, keyinfo:{}, options:{}, data:{} },
      form:{}, showTemplate:false, currentTemplate:null,
    }
  },
  async created(){ this.page=this.$fan.utils.parse(this.def.page); await this.loadTemplate() },
  mounted(){ this.showTemplate=false; this.loadData() },
  computed:{
    columns(){
      const c={}; for(let k in this.data.columns){const col=this.data.columns[k]; if(!col.hidden||col.hidden.indexOf('detail')<0)c[k]=col}
      return c
    },
    columnEntries(){
      return Object.keys(this.columns).map(key => ({ key, column: this.columns[key] }))
    },
    api(){
      let a=this.$fan.utils.parse(this.superApi).split('?')[0]
      if(a&&a.indexOf('v_')>-1)return a.split('v_')[1]; if(a&&a.indexOf('v2_')>-1)return a.split('v2_')[1]; return a
    },
    defaultFormValue(){return{}}
  },
  watch:{
    async template(n){ if(n){ await this.loadTemplateComponent(n)}}
  },
  /* 使用 render 函数替代 template，解决 Vue3 编译器不支持 v-for + 动态插槽名的问题 */
  render(){
    const children = []

    if(this.currentTemplate && this.showTemplate){
      const isDetail = this.mold === 'detail'
      const slots = {}

      for(const entry of this.columnEntries){
        const key = entry.key
        const col = entry.column

        let skip = false
        if(isDetail){
          skip = col.hidden && col.hidden.indexOf('detail') >= 0
        } else {
          if(this.mold === 'add') skip = col.hidden && col.hidden.indexOf('add') >= 0
          else if(this.mold === 'edit') skip = col.hidden && col.hidden.indexOf('edit') >= 0
        }

        if(skip) continue

        slots[key] = () => isDetail ? this.renderDetailSlot(key, col) : this.renderFormSlot(key, col)
      }

      children.push(h(this.currentTemplate, { class:'FTemplate', ref:'printBody', mixData: this.mixData }, slots))
    } else if(this.showTemplate){
      children.push(h('div', { class:'FTemplate' }, '报表内容加载中...'))
    }

    children.push(h('form', { ref:'pdf', action:'http://pdf.119.7jj.org.cn/', method:'POST', target:'_blank', style:{display:'none'} }, [
      h('input', { type:'hidden', name:'payload', value:this.page.printData })
    ]))

    return h('div', { class:'fan fan-component', ref:'f-report' }, children)
  },
  methods:{
    async loadTemplate(){
      try{ const m=await import(/*webpackChunkName:"report-tpl"*/ `@/pages/components/${this.template||'Index'}.vue`); this.currentTemplate=markRaw(m.default) }
      catch(e){ console.warn('模板加载失败:',e.message); this.currentTemplate=null }
    },
    async loadTemplateComponent(name){
      try{ const m=await import(/*webpackChunkName:"report-tpl-dyn"*/ `@/pages/components/${name}.vue`); this.currentTemplate=markRaw(m.default) }catch(e){}
    },
    getOptionName(f,v){ return this.$fan.page.getOptionName(f,v) },
    splitData(d){ return d?(typeof d==='string'?d.split(','):[d]):[] },

    /* ====== detail（查看）模式渲染 ======= */
    renderDetailSlot(key, col){
      const val = this.data.data[key]
      if(['select','selectTree','radio'].indexOf(col.form) > -1){
        return h('span', String(this.getOptionName(key, val)))
      }
      if(col.form === 'cascader'){
        return h('span', String(this.getOptionName(key, val ? val[val.length-1] : null)))
      }
      if(col.form === 'esign'){
        return this.renderEsignDetail(val)
      }
      if(col.form === 'image'){
        if(!val) return null
        return h(resolveComponent('a-popover'), { position:'left' }, {
          content: () => h('img', { style:{maxWidth:'400px',maxHeight:'400px'}, src:val }),
          default: () => h('img', { style:{maxWidth:'100px',maxHeight:'100px'}, src:val })
        })
      }
      if(col.form === 'images'){
        const items = val || []
        return items.map((item, idx) =>
          h(resolveComponent('a-popover'), { key:'im'+idx, position:'left' }, {
            content: () => h('img', { style:{maxWidth:'400px',maxHeight:'400px'}, src:item }),
            default: () => h('img', { style:{maxWidth:'100px',maxHeight:'100px'}, src:item })
          })
        )
      }
      if(col.form === 'json'){
        return this.renderJsonDetail(key, col, val)
      }
      // editor/quilleditor 类型：查看模式下渲染 HTML 内容
      if(['editor','quilleditor','quilleditor2'].indexOf(col.form) > -1){
        return h('div', { class:'freport-editor-detail', innerHTML: val || '' })
      }
      return h('span', val != null ? String(val) : '')
    },

    renderEsignDetail(val){
      if(!val) return null
      if(String(val).indexOf(',') === -1){
        return h(resolveComponent('a-popover'), { position:'left' }, {
          content: () => h('img', { style:{maxWidth:'400px',maxHeight:'300px'}, src:val }),
          default: () => h('img', { style:{maxWidth:'100px',maxHeight:'100px'}, src:val })
        })
      }
      const items = this.splitData(val)
      return items.map((item, idx) =>
        h(resolveComponent('a-popover'), { key:'e'+idx, position:'left' }, {
          content: () => h('img', { style:{maxWidth:'400px',maxHeight:'400px'}, src:item }),
          default: () => h('img', { style:{maxWidth:'100px',maxHeight:'100px'}, src:item })
        })
      )
    },

    renderJsonDetail(key, col, val){
      const els = []
      if(col.name === '作业事前检查' && val && val.length > 0){
        els.push(h('div', { style:{clear:'both',width:'100%',marginTop:'50px',textAlign:'center'} }, col.name))
        els.push(h('table', { border:'1', width:'100%', align:'center' }, val.map((item, idx) =>
          h('thead', { key:'p'+idx }, [
            h('tr', [h('td',{class:'tdHeader'},'点检日期'), h('td',String(item.addtime)), h('td',{class:'tdHeader'},'作业名称'), h('td',String(this.getOptionName('id_tlsp',item.id_tlsp)))]),
            h('tr', [h('td',{class:'tdHeader'},'是否签到'), h('td',String(this.getOptionName('qdyesno',item.qdyesno))), h('td',{class:'tdHeader'},'点检结果'), h('td',String(this.getOptionName('jieguozhencyic',item.jieguozhencyic)))]),
          ])
        )))
      }
      if(col.name === '作业事中点检' && val && val.length > 0){
        els.push(h('div', { style:{clear:'both',width:'100%',marginTop:'50px',textAlign:'center'} }, col.name))
        els.push(h('table', { border:'1', width:'100%', align:'center' }, val.map((item, idx) =>
          h('thead', { key:'m'+idx }, [
            h('tr', [h('td',{class:'tdHeader'},'点检日期'), h('td',String(item.addtime)), h('td',{class:'tdHeader'},'作业名称'), h('td',String(this.getOptionName('id_tlsp',item.id_tlsp)))]),
            h('tr', [h('td',{class:'tdHeader'},'是否签到'), h('td',String(this.getOptionName('qdyesno',item.qdyesno))), h('td',{class:'tdHeader'},'点检结果'), h('td',String(this.getOptionName('jieguozhencyic',item.jieguozhencyic)))]),
          ])
        )))
      }
      return els
    },

    /* ====== add/edit（新增/编辑）模式渲染 ======= */
    renderFormSlot(key, col){
      const placeholder = col.placeholder || col.title
      const disabled = col.disabled || false
      const onChange = (v)=>{ this.form[key]=v }

      switch(col.form){
        case 'input':
          return h(resolveComponent('a-input'), { modelValue:this.form[key], placeholder, disabled, size:'small', 'onUpdate:modelValue':onChange })
        case 'textarea':
          return h(resolveComponent('a-textarea'), { rows:4, modelValue:this.form[key], placeholder, disabled, 'onUpdate:modelValue':onChange })
        case 'number':
          return h(resolveComponent('a-input-number'), { modelValue:this.form[key], disabled, size:'small', 'onUpdate:modelValue':onChange })
        case 'select':
        case 'selectTree':
          return h(resolveComponent('a-select'), { modelValue:this.form[key], options:this.data.options[key], placeholder, disabled, size:'small', 'onUpdate:modelValue':onChange })
        case 'radio':
          return h(resolveComponent('a-radio-group'), { modelValue:this.form[key], options:this.data.options[key], disabled, 'onUpdate:modelValue':onChange })
        case 'selectMultiple':
          return h(resolveComponent('a-select'), { mode:'multiple', modelValue:this.form[key], options:this.data.options[key], disabled, size:'small', 'onUpdate:modelValue':onChange })
        case 'cascader':
          return h(resolveComponent('a-cascader'), { expandTrigger:'hover', changeOnSelect:true, placeholder:'', modelValue:this.form[key], options:this.data.options[key], disabled, showSearch:{filterMethod:this.bindSearchCascader}, size:'small', 'onUpdate:modelValue':onChange })
        case 'monthpicker':
          return h(resolveComponent('a-date-picker'), { mode:'month', format:'YYYY-MM', modelValue:this.form[key], disabled, style:{width:'200px'}, size:'small', 'onUpdate:modelValue':onChange })
        case 'datepicker':
          return h(resolveComponent('a-date-picker'), { mode:'date', format:'YYYY-MM-DD', modelValue:this.form[key], disabled, style:{width:'200px'}, size:'small', 'onUpdate:modelValue':onChange })
        case 'datetimepicker':
          return h(resolveComponent('a-date-picker'), { mode:'datetime', format:'YYYY-MM-DD HH:mm:ss', showTime:true, modelValue:this.form[key], disabled, style:{width:'200px'}, size:'small', 'onUpdate:modelValue':onChange })
        case 'timepicker':
          return h(resolveComponent('a-time-picker'), { format:'HH:mm', modelValue:this.form[key], disabled, style:{width:'200px'}, 'onUpdate:modelValue':onChange })
        case 'switch':
          return h(resolveComponent('a-checkbox-group'), { modelValue:this.form[key], 'onUpdate:modelValue':onChange }, ()=>[h(resolveComponent('a-checkbox'), { value:'checked' })])
        case 'checkbox1':
          return h(resolveComponent('a-checkbox'), { modelValue:this.form[key], disabled, 'onUpdate:modelValue':onChange })
        case 'checkbox':
          return h(resolveComponent('a-checkbox-group'), { modelValue:this.form[key], options:this.data.options[key], disabled, 'onUpdate:modelValue':onChange })
        case 'esign':
          return h(resolveComponent('f-esign'), { name:key, value:this.form[key], suDisabled:disabled, onChange:(f,v)=>this.bindUploadImage(f,v) })
        case 'esignbm':
          return h(resolveComponent('f-esign-bm'), { name:key, value:this.form[key], suDisabled:disabled, onChange:(f,v)=>this.bindUploadImage(f,v) })
        case 'image':
          return h(resolveComponent('f-upload-image'), { name:key, value:this.form[key], disabled, onChange:(f,v)=>this.bindUploadImage(f,v) })
        case 'images':
          return h(resolveComponent('f-upload-images'), { name:key, limit:8, value:this.form[key], disabled, onChange:(f,l)=>this.bindUploadImages(f,l) })
        case 'score':
          return h(resolveComponent('a-select'), { modelValue:this.form[key], disabled, size:'small', 'onUpdate:modelValue':onChange }, ()=>{
            const optEls = [h(resolveComponent('a-option'), { value:0 }, ()=>'0')]
            if(col.setting && col.setting.max){
              for(let k in col.setting.max){ optEls.push(h(resolveComponent('a-option'), { key:'s'+k, value:col.setting.max[k] }, ()=>String(col.setting.max[k]))) }
            }
            return optEls
          })
        case 'editor':
        case 'quilleditor':
        case 'quilleditor2':
          // 富文本编辑器（Quill）
          const QuillEditor = require('@vueup/vue-quill').QuillEditor
          const quillOpts = this.getQuillOptions(col)
          return h('div', { class:'freport-quill-wrap' }, [
            h(QuillEditor, {
              ref:'ql_'+key,
              contentType:'html',
              theme:'snow',
              content: this.form[key] || '',   // 初始内容（HTML字符串）
              options: quillOpts,
              disabled,
              'onUpdate:content': (v) => { this.form[key] = v }
            })
          ])
        case 'show':
          return h('span', String(this.form[key]))
        default:
          return h('span', '未知Form类型')
      }
    },

    /* ========== 原有方法保持不变 ========== */
    async loadData(){
      this.page.loading.page=true
      const d=this.$store.state.page
      this.data=this.$fan.utils.parse(d)
      this.data.data=this.$fan.utils.parse(this.superData)
      this.form=await this.recombineDataByUserToForm(this.data.data,this.data.columns)
      this.form=await this.recombineDataToForm(this.data.data,this.data.columns)
      this.page.loading.page=false
      this.showTemplate=true
    },
    async actionFormSubmit(){
      this.page.loading.submit=true
      let req, fn=this.mold==='edit'?'checkEditFormToReq':'checkAddFormToReq'
      req=this[fn](this.$fan.utils.parse(this.form),this.$fan.utils.parse(this.data.data),this.$fan.utils.parse(this.data.columns))
      if(req.error_message){ this.$message.warning(req.error_message)}
      else if(this.$fan.utils.notEmpty(req)){ this.$emit('bindFormSubmit',this.mold,req)}
      else{ this.$message.warning('未检测到任何修改')}
      this.page.loading.submit=false
    },
    async recombineDataByUserToForm(data,columns){
      const ki=this.$fan.utils.parse(this.data.keyinfo), form={}, u=this.$store.state.user
      if(u.id_auth_role>1&&u.id_entity){
        let f
        if(columns.id_entity)f='id_entity'
        else if(columns.id_entity_xiaofang)f='id_entity_xiaofang'
        else if(columns.id_base_org)f='id_base_org'
        if(f&&ki[f]) form[f]=ki[f][u.id_entity].value
      }
      return form
    },
    async recombineDataToForm(data,columns){
      const ki=this.$fan.utils.parse(this.data.keyinfo), form={}
      for(let field in columns){
        const c=columns[field]
        if(!c.hidden||c.hidden.indexOf(this.mold)<0){
          if(c.form==='password'){ form[field]=''}
          else if(['cascader'].indexOf(c.form)>-1 && ki[`${field}`] && ki[`${field}`][data[field]]){ form[field]=ki[`${field}`][data[field]].value}
          else if(data[field] && ['selectTree'].indexOf(c.form)>-1){ form[field]=`${data[field].join(",")}`.split(",")}
          else if(['checkbox'].indexOf(c.form)>-1){
            if(this.mold!=='detail'){ form[field]=data[field]?JSON.parse(JSON.stringify(data[field])):[]}
            else{
              if(data[field]){ form[field]=[]; for(let k in data[field]) form[field].push(ki[`${field}`][data[field][k]].name); form[field]=form[field].join('、')}
              else{ form[field]=''}
            }
          }
          else if(c.form==='mapPoint'){ form[field]=(data[field]&&data[field].x)?{lng:data[field].x,lat:data[field].y}:{lng:114.703611,lat:33.632539}}
          else if(this.mold!=='detail'&&['monthpicker'].indexOf(c.form)>-1){ form[field]=data[field]?moment(data[field],'YYYY-MM'):undefined}
          else if(this.mold!=='detail'&&['datepicker'].indexOf(c.form)>-1){ form[field]=data[field]?moment(data[field],'YYYY-MM-DD'):undefined}
          else if(this.mold!=='detail'&&['datetimepicker'].indexOf(c.form)>-1){ form[field]=data[field]?moment(data[field],'YYYY-MM-DD HH:mm:ss'):undefined}
          else if(this.mold!=='detail'&&['timepicker'].indexOf(c.form)>-1){ form[field]=data[field]?moment(data[field],'HH:mm:ss'):undefined}
          else if(['switch'].indexOf(c.form)>-1){ form[field]=this.mold!=='detail'?(data[field]?['checked']:[]):(data[field]?'√':'▢')}
          else{ if(['text[]','int[]'].indexOf(c.type)>-1 && !(data[field]||data[field]===false||data[field]===''||data[field]===0)){ form[field]=[]} else{ form[field]=data[field]}}

          if(this.superFilter && this.superFilter[field]){ form[field]=this.$fan.utils.parse(this.superFilter[field])}
          if(form[field]!=null && form[field]!=undefined){ this.data.data[field]=form[field]}
          else{ form[field]=this.form[field]; this.data.data[field]=this.form[field]}
        }
      }

      if(this.mold==='detail'){ for(let k in this.mixData){ if(columns[k]&&(columns[k].disable||(columns[k].form&&['show','hidden'].indexOf(columns[k].form)>-1))) this.data.data[k]=this.mixData[k]}}
      else if(this.mold==='edit'){ for(let k in this.mixData){ if(columns[k]&&(columns[k].disable||(columns[k].form&&['show','hidden'].indexOf(columns[k].form)>-1))) form[k]=this.mixData[k]}}
      else if(this.mold==='add'){ for(let k in this.mixData) form[k]=this.mixData[k]}
      return form
    },
    checkEditFormToReq(form,data,columns){
      const req={}
      for(let f in columns){
        const c=columns[f]
        if(!c.hidden||c.hidden.indexOf(this.mold)<0){
          if(c.required&&c.required===true&&c.form!=='password'&&!form.hasOwnProperty(f)&&this.$fan.utils.notSet(form[f]))return{error_message:`"${c.name}"是必填项`}
          if((form[f]||form[f]===false||form[f]===''||form[f]===0)){
            if(c.form==='password')req[f]=md5(form[f])
            else if(['cascader'].indexOf(c.form)>-1)req[f]=parseInt(form[f][form[f].length-1])
            else if(['selectTree'].indexOf(c.form)>-1)req[f]=JSON.parse(`[${form[f].join(',')}]`)
            else if(c.form==='mapPoint')req[f]=[form[f].lng,form[f].lat]
            else if(c.form==='timepicker')req[f]=moment(form[f]).format('HH:mm:ss')
            else if(c.form==='monthpicker')req[f]=moment(form[f]).format('YYYY-MM')
            else if(['switch'].indexOf(c.form)>-1)req[f]=form[f].length>0?true:false
            else req[f]=form[f]
          }
        }
      }
      return req
    },
    checkAddFormToReq(form,data,columns){
      const req={}
      for(let f in columns){
        const c=columns[f]
        if(!c.hidden||c.hidden.indexOf(this.mold)<0){
          if(c.required&&c.required===true&&!form.hasOwnProperty(f)&&this.$fan.utils.notSet(form[f]))return{error_message:`"${c.name}"是必填项`}
          if((form[f]||form[f]===false||form[f]===''||form[f]===0)){
            if(c.form==='password')req[f]=md5(form[f])
            else if(['cascader'].indexOf(c.form)>-1)req[f]=parseInt(form[f][form[f].length-1])
            else if(['selectTree'].indexOf(c.form)>-1)req[f]=JSON.parse(`[${form[f].join(',')}]`)
            else if(c.form==='mapPoint')req[f]=[form[f].lng,form[f].lat]
            else if(c.form==='timepicker')req[f]=moment(form[f]).format('HH:mm:ss')
            else if(c.form==='monthpicker')req[f]=moment(form[f]).format('YYYY-MM')
            else if(['switch'].indexOf(c.form)>-1)req[f]=form[f].length>0?true:false
            else req[f]=form[f]
          }
        }
      }
      for(let k in this.defaultFormValue) req[k]=this.defaultFormValue[k]
      return req
    },
    bindSearchCascader(inputValue,path){ return path.some(o=>o.label.toLowerCase().indexOf(inputValue.toLowerCase())>-1) },
    async actionDetailPrint(){
      if(this.$refs.printBody){
        const el = this.$refs.printBody.$el || this.$refs.printBody
        if(el) print(el)
      }
    },
    bindUploadImage(f,v){ this.form[f]=v },
    bindUploadImages(f,l){ this.form[f]=l },

    /* Quill 编辑器选项配置 */
    getQuillOptions(col) {
      const opts = {
        placeholder: col.placeholder || '请输入内容...',
        modules: {
          toolbar: [
            [{ header: [1, 2, 3, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ color: [] }, { background: [] }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['clean']
          ]
        }
      }
      // quilleditor2 用精简工具栏
      if (col.form === 'quilleditor2') {
        opts.modules.toolbar = [['bold', 'italic'], ['clean']]
      }
      return opts
    },
  }
}
</script>
